export default function SectionAbout() {
  return (
    <section id="about" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto text-center">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
          平台介绍
        </h2>

        <div className="mt-8 p-6 md:p-10 rounded-2xl bg-background-100 border border-background-300/40">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-500/15 mb-6">
            <i className="ri-movie-2-line text-primary-400 text-2xl"></i>
          </div>

          <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-2xl mx-auto">
            <strong className="text-foreground-100 font-semibold">麻花影视</strong>是一个聚合型高清影视在线观看平台，致力于为影迷提供一站式的观影体验。我们深度整合<strong className="text-foreground-100 font-semibold">飘花电影网</strong>、<strong className="text-foreground-100 font-semibold">555电影</strong>、<strong className="text-foreground-100 font-semibold">8090电影网</strong>等主流资源平台的内容，覆盖电影、电视剧、综艺、动漫等全品类影视内容。
          </p>

          <p className="mt-4 text-sm md:text-base text-foreground-400 leading-relaxed max-w-2xl mx-auto">
            自上线以来，麻花影视始终坚持「免费、高清、不缓冲」的服务理念，通过智能CDN加速和自适应码率技术，为用户提供流畅的观影体验。无论是最新上映的院线大片，还是经典的老片重温，亦或是热播的电视剧和综艺节目，麻花影视都能满足您的观影需求。未来我们将持续优化产品体验，拓展更多优质内容资源，让每一位用户都能在这里找到喜欢的影视作品。
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-8 pt-6 border-t border-background-300/30">
            <div className="text-center">
              <div className="text-lg md:text-xl font-black text-primary-400 font-heading">100,000+</div>
              <div className="text-xs text-foreground-600 mt-1">高清片源</div>
            </div>
            <div className="text-center">
              <div className="text-lg md:text-xl font-black text-accent-400 font-heading">99.7%</div>
              <div className="text-xs text-foreground-600 mt-1">播放成功率</div>
            </div>
            <div className="text-center">
              <div className="text-lg md:text-xl font-black text-secondary-400 font-heading">7×24h</div>
              <div className="text-xs text-foreground-600 mt-1">内容更新</div>
            </div>
            <div className="text-center">
              <div className="text-lg md:text-xl font-black text-foreground-300 font-heading">全免费</div>
              <div className="text-xs text-foreground-600 mt-1">无需会员</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}